import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgStarFill(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.5em"
      height="1.5em"
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.1351 3.47644C16.9308 3.03361 16.4877 2.75 16 2.75C15.5123 2.75 15.0692 3.03361 14.8649 3.47644L11.4902 10.7928L3.4891 11.7415C3.00482 11.7989 2.59815 12.1327 2.44745 12.5965C2.29675 13.0603 2.42955 13.5694 2.78758 13.9005L8.70302 19.3709L7.13277 27.2736C7.03773 27.7519 7.22954 28.2418 7.62407 28.5285C8.0186 28.8151 8.54381 28.8462 8.96935 28.608L16 24.6725L23.0307 28.608C23.4562 28.8462 23.9814 28.8151 24.3759 28.5285C24.7705 28.2418 24.9623 27.7519 24.8673 27.2736L23.297 19.3709L29.2124 13.9005C29.5705 13.5694 29.7033 13.0603 29.5526 12.5965C29.4019 12.1327 28.9952 11.7989 28.5109 11.7415L20.5098 10.7928L17.1351 3.47644Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgStarFill);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
